import HttpService from "../HttpService";

export async function getUserTeam(token) {
  try {
    return await HttpService.account().setPath("/team").setToken(token).get();
  } catch (e) {
    return {data: null};
  }
}

export async function getTeamMembers(
  token,
  page,
  offset,
  sort = false,
  type = false
) {
  return await HttpService.account()
    .setPath("/team/members")
    .setToken(token)
    .setParams({ page, per_page: offset, sort, type })
    .get();
}

export async function changeUserStatus(token, data) {
  return await HttpService.account()
    .setPath("/team-admin/toggole-stat")
    .setToken(token)
    .setBody(data)
    .post();
}

export async function createTeam(token, data) {
  return await HttpService.account()
    .setPath("/team")
    .setToken(token)
    .setBody(data)
    .post();
}

export async function inviteMembers(token, data) {
  return await HttpService.account()
    .setPath("/team-admin/invite")
    .setToken(token)
    .setBody(data)
    .post();
}

export async function editTeam(token, id, data) {
  return await HttpService.account()
    .setPath("/team/" + id)
    .setToken(token)
    .setBody(data)
    .patch();
}

export async function deleteTeam(token, id) {
  return await HttpService.account()
    .setPath("/team/" + id)
    .setToken(token)
    .delete();
}

export async function deleteTeamMember(token, id, data) {
  return await HttpService.account()
    .setPath("/team-admin/remove/" + id)
    .setToken(token)
    .setBody(data)
    .delete();
}

export async function leaveTeam(token) {
  return await HttpService.account()
    .setPath("/team-member/leave/")
    .setToken(token)
    .delete();
}

export async function changeRole(token, data) {
  return await HttpService.account()
    .setPath("/team-admin/change-member-role/")
    .setToken(token)
    .setBody(data)
    .post();
}
